<template>
  <div class="export-cv-modal">
    <v-layout justify-center>
      <v-dialog v-model="showExport" max-width="700">
        <v-card color="#FFF">
          <v-layout>
            <div class="card__body">
              <div class="__cont">
                <label class="__colored">Export Your CV.</label>
                <span>Format:</span>
                <div class="icons">
                  <div>
                    <input name="download-type" type="radio" value="pdf" v-model="download_type" />
                    <label>Pdf</label>
                  </div>
                  <div>
                    <input name="download-type" type="radio" value="json" v-model="download_type" />
                    <label>json</label>
                  </div>
                  <div>
                    <input name="download-type" type="radio" value="docx" v-model="download_type" />
                    <label>Word</label>
                  </div>
                </div>
                <label v-if="download_type == 'docx'">Select Template</label>
                <label v-else>Template</label>
                <div class="body">
                  <div class="template">
                    <img
                      src="@/assets/images/json_temp.png"
                      style="width:150px"
                      v-if="download_type == 'json'"
                    />
                    <div class="templ" v-if="download_type == 'docx' || download_type == 'pdf'">
                      <ul>
                        <li v-for="n in 4" :key="n">
                          <input
                            name="temp_name"
                            class="temp_docx"
                            type="radio"
                            :value="n == 1 ? 'cvs/template_'+n+'.'+download_type : 'template'+(n)+'.'+download_type"
                            v-model="temp_name"
                          />

                          <img
                            v-if="n == 1"
                            src="@/assets/images/temp_docs/new/1.svg"
                            style="width:50px"
                          />
                          <img
                            v-if="n == 2"
                            src="@/assets/images/temp_docs/new/2.svg"
                            style="width:50px"
                          />
                          <img
                            v-if="n == 3"
                            src="@/assets/images/temp_docs/new/3.svg"
                            style="width:50px"
                          />
                          <img
                            v-if="n == 4"
                            src="@/assets/images/temp_docs/new/4.svg"
                            style="width:50px"
                          />
                          <label v-if="n == 1">Basic</label>
                          <label v-if="n == 2">Vanirra</label>
                          <label v-if="n == 3">Classic</label>
                          <label v-if="n == 4">Fancy</label>
                          <label v-if="n == 5">Default</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="actiond">
                  <consultfied-button @click="exportCV()" class="__btn" :loading="loading">Export CV</consultfied-button>

                  <button class="cancel" @click="onClose()">Cancel</button>
                </div>
              </div>
            </div>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
export default {
  name: "export-cv",
  components: {
    consultfiedButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    names: {
      type: String,
      default: "file",
    },
  },
  data: () => {
    return {
      show: true,
      showExport: false,
      download_type: "pdf",
      temp_name: "template1.docx",
      loading: false,
    };
  },
  watch: {
    visible: function (val) {
      this.showExport = val;
    },
  },
  mounted() {
    this.showExport = this.visible;
  },
  methods: {
    exportCV() {
      this.loading = true;
      if (this.download_type == "docx" || this.download_type == "pdf") {
        this.$store
          .dispatch("EXPORT_CV", {
            type: this.download_type,
            names: this.names + " CV",
            template: this.temp_name,
            temp_name: this.temp_name,
          })
          .then((responce) => {
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      } else {
        this.$store
          .dispatch("EXPORT_CV", {
            type: this.download_type,
            names: this.names + " CV",
          })
          .then((responce) => {
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
          });
      }
    },
    onClose() {
      let vm = this;
      this.$emit("onClose", null);
    },
  },
};
</script>
<style lang="scss">
.card__body {
  padding: 20px;
  z-index: 9999;
  width: 100%;
  .__cont {
    display: flex;
    flex-direction: column;
    .icons {
      display: flex;
      width: 100%;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 0.7px solid #a0a0a0;
      margin-top: 10px;
      div {
        margin-right: 30px;
        label {
          font-size: 12px;
        }
        input {
          margin-right: 10px;
          margin-top: 5px;
        }
      }
    }
    .body {
      padding: 20px;
      border-radius: 5px;
      background: #f4f4f4;
      border: 1px solid #707070;
      width: 100%;
      .template {
        background: #fff;
        box-shadow: 0 6px 5px rgba(0, 0, 0, 0.16);
        margin-right: 10px;
        width: 100%;
        button {
          height: 10px;
          font-size: 4px;
          outline: none;
          color: #fff;
          border: none;
          background: #0e9695;
        }
        .header {
          display: flex;
          width: 100%;
          .first {
            display: flex;
            padding-left: 10px;
            padding-right: 10px;
            flex-direction: column;
            img {
              width: 30px;
              height: 30px;
              border-radius: 100%;
            }
            h2 {
              font-size: 6px;
              margin-top: 10px;
            }
          }
          .second {
            background: #0075a0;
            display: flex;
            flex-grow: 1;
            justify-content: center;
            align-items: center;
            .titles {
              display: flex;
              color: #fff;
              width: 100%;
              justify-content: space-between;
              padding-left: 10px;
              padding-right: 10px;
              h2 {
                font-size: 4px;
              }
              button {
                height: 10px;
                font-size: 4px;
                outline: none;
                border: none;
                background: #0e9695;
              }
            }
          }
        }
        .contents {
          display: flex;
          width: 100%;
          span,
          p,
          button {
            font-size: 4px !important;
          }
          .left {
            width: 100px;
          }
          .right {
            flex-grow: 1;
          }
        }
        .templ {
          ul {
            list-style: none;
            padding: 15px 15px;
            display: grid;
            grid-template-columns: 48% 48%;
            grid-gap: 20px;
            li {
              align-items: center;
              display: flex;
              margin-top: 10px;
              .temp_docx {
                margin-right: 10px;
              }
              img {
                margin-right: 10px;
                border: 1px solid #ccc;
              }
            }
          }
        }
      }
    }
    .actiond {
      margin-top: 10px;
      display: flex;
      button {
        background: #1890a9;
        color: #fff;
        border-radius: 5px;
        padding: 5px 10px;
        justify-content: space-between;
        align-items: center;
      }
      .cancel {
        background: transparent;
        color: #0590ab;
      }
    }
  }
}
</style>
